export default __webpack_public_path__ + "static/media/facebook.ed8016d4.svg";